import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import Velocity from 'velocity-animate';

import Icon from '@wetransfer/transfer/component/icon';

const MobileSubnav = ({ children, hasSubSubNav, subSubNavOpen }) => {
  const subMenuRef = useRef(null);

  useEffect(() => {
    if (hasSubSubNav) {
      if (subSubNavOpen) {
        Velocity(subMenuRef, 'slideDown', {
          duration: 150,
          easing: [0.77, 0.0, 0.175, 1.0],
        });
      }
    }
  }, [hasSubSubNav, subSubNavOpen]);

  return (
    <div ref={subMenuRef} className="nav__subitems-container">
      <Icon type="Pointer" />
      <ul className="nav__subitems">{[...children]}</ul>
    </div>
  );
};

MobileSubnav.propTypes = {
  children: PropTypes.array,
  hasSubSubNav: PropTypes.bool,
  subSubNavOpen: PropTypes.bool,
};

export default MobileSubnav;
